import React, { useEffect, useState } from 'react';
import { Grid, Paper, useMediaQuery } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';


import { useParams } from 'react-router-dom';
import { fetchPartyInwardData } from '../../../Store/PHPSlice/PartyInward/PartyInwApi';
import { selectPartyInwData } from '../../Selectors/Master/MasterSelectors';

const PartyInwView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        totqty: '',
        totmat: '',
        userId: '1'
    });
    const [material, setMaterial] = useState([]);
    const [itemQty, setItemQty] = useState({
        size: [],
        qty: []
    });

    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const partyInwlist = useSelector(selectPartyInwData);

    useEffect(() => {
        dispatch(fetchPartyInwardData(Id));
    }, [dispatch, Id]);

    useEffect(() => {
        if (partyInwlist?.material?.length > 0) {
            const data = partyInwlist?.material;
            setMaterial(data);
        }
        if (partyInwlist?.itemdata?.length > 0) {
            const sizearr = partyInwlist?.itemdata?.map((val) => val.size);
            const qtyarr = partyInwlist?.itemdata?.map((val) => val.qty);
            setItemQty({
                size: sizearr,
                qty: qtyarr
            });

        }
        if (partyInwlist?.data) {
            const totqty = partyInwlist?.data?.totqty;
            const totmat = partyInwlist?.data?.totmtqty;
            setFormData(prev => ({
                ...prev,
                totmat: totmat,
                totqty: totqty
            }))
        }
    }, [partyInwlist]);


    const isDesktop = useMediaQuery('(min-width:768px)');


    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Party Inward View</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {material.length > 0 &&
                                    <div className="lump-content">
                                        <h3>Material Details </h3>

                                        <table style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Material Work</th>
                                                    <th>Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {material.map((mat, matIndex) => (
                                                    <>
                                                        <tr key={matIndex}>
                                                            <td>
                                                                {matIndex + 1}
                                                            </td>
                                                            <td>
                                                                {mat.materialNm}
                                                            </td>
                                                            <td>
                                                                {mat.qty}
                                                            </td>
                                                        </tr>
                                                    </>
                                                ))}
                                                <tr>
                                                    <td> </td>
                                                    <td>
                                                        <span className="tot-lump">Total Qty</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmat}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                }

                                {itemQty?.size.length > 0 &&
                                    <Grid item xs={12} md={6}>
                                        <div>
                                            <h3>Item Details : Total Qty.  {formData.totqty}</h3>
                                            <table style={{ width: '100%' }}>
                                                <tbody>
                                                    <tr>
                                                        <td>Size</td>
                                                        {itemQty?.size?.map((val, valIndex) => (
                                                            <td key={valIndex}>
                                                                {val}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                    <tr>
                                                        <td>Qty</td>
                                                        {itemQty?.qty?.map((val, valIndex) => (
                                                            <td key={valIndex}>
                                                                {val}
                                                            </td>
                                                        ))}
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>

                                    </Grid>
                                }

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid >
            </div >
        </>
    );
}

export default PartyInwView;
